import React, { useContext } from "react";
import { useLocation } from "react-router-dom";

import { WorkshopContext } from "../../contexts/workshop.context";
import { defaultPlatforms, defaultRoles, NonPrivateRoutes } from "../../util/workshop.util";
import QRPopup from "./qrPopup";

const ScreenBottom = ({ extraClasses, fixed, helperText, children }) => {
  const location = useLocation();

  const { user: { role } = {}, workshopDetails: { teamName, platform } = {} } =
    useContext(WorkshopContext);

  return (
    <div
      id="screen-bottom"
      className={`${
        fixed
          ? "fixed bottom-0 left-0 w-full pt-0 before:content-[''] before:absolute before:top-[-40px] before:left-0 before:right-0 before:h-[40px] before:bg-gradient-to-b before:from-transparent before:to-orange-50"
          : "mt-10"
      } bottom-0 left-0 right-0 w-full p-4 pb-12 bg-orange-50 z-10`}>
      {role !== defaultRoles.participant && helperText && (
        <div
          className="text-base text-gray-500 text-center my-2"
          dangerouslySetInnerHTML={{ __html: helperText }}
        />
      )}
      <div
        className={`w-full sm:max-w-md mx-auto flex items-center justify-center gap-4 ${extraClasses}`}>
        {children}
      </div>
      {(role === defaultRoles.moderator || role === defaultRoles.moderatorAndParticipant) &&
        platform !== defaultPlatforms.mtDemo &&
        !NonPrivateRoutes.includes(location.pathname) && (
          <QRPopup teamName={teamName} floating={false} />
        )}
    </div>
  );
};

export default ScreenBottom;
